import script from "./addThirdPersonForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./addThirdPersonForm.vue?vue&type=script&setup=true&lang=ts"

import "./addThirdPersonForm.vue?vue&type=style&index=0&id=64fd3908&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64fd3908"]])

export default __exports__